import React, { useEffect, useState } from "react"
import { isValidJSON, isValidPolygon, isValidPolygonWKT } from "../../util/projectSettings"
// import { numberOfCoordinatesPairsEntered } from "../../util/projectSettings"
// import { isFirstEqualToLast } from "../../util/projectSettings"
import { isValidCoordinateString } from "../../util/projectSettings"
import { ApolloError } from "@apollo/client"
import { PendingSpinner } from "../Pending"
import { BoundaryInputType, CRSType } from "../../types"
interface ProjectBoundryFormProp {
  formData: any
  setFormData: React.Dispatch<React.SetStateAction<any>>
  initialFormData: any
  t: any
  setWarning: React.Dispatch<React.SetStateAction<{ value: boolean; messssage: string }>>
  warning: { value: boolean; messssage: string }
  geoCooedinatesError?: ApolloError
  geoCoordinatesLoading?: boolean
  active: CRSType
  boundaryInput: BoundaryInputType
  loading?: boolean
}
export const ProjectBoundaryForm = (props: ProjectBoundryFormProp) => {
  const {
    formData,
    setFormData,
    t,
    warning,
    setWarning,
    initialFormData,
    geoCooedinatesError,
    geoCoordinatesLoading,
    loading
  } = props
  useEffect(() => {
    if (geoCooedinatesError) {
      setWarning({ value: true, messssage: geoCooedinatesError.message })
    }
  }, [geoCooedinatesError, setWarning])

  const handleJSONChange = (e: any) => {
    const { value } = e.target
    setFormData(value)
    if (value === "") {
      setWarning({
        value: true,
        messssage:
          props.active === CRSType.GeoCRS
            ? t("connectSettings.warningMessages.emptyInputGeo")
            : t("connectSettings.warningMessages.emptyInputProjected")
      })
    } else if (!isValidJSON(value)) {
      setWarning({ value: true, messssage: t("connectSettings.warningMessages.invalidJSON") })
    } else if (value === initialFormData) {
      setWarning({ value: true, messssage: t("connectSettings.warningMessages.unChangedInput") })
    } else if (!isValidCoordinateString(value)) {
      setWarning({ value: true, messssage: t("connectSettings.warningMessages.default") })
    } else if (!isValidPolygon(value)) {
      setWarning({ value: true, messssage: t("connectSettings.warningMessages.notABoundary") })
    } else {
      setWarning({
        value: false,
        messssage: ""
      })
    }
  }

  const handleWKTChange = (e: any) => {
    const { value } = e.target
    setFormData(value)
    if (value === "") {
      setWarning({
        value: true,
        messssage: t("connectSettings.warningMessages.emptyInputWKT")
      })
    } else if (value === initialFormData) {
      setWarning({ value: true, messssage: t("connectSettings.warningMessages.unChangedInput") })
    } else if (!isValidPolygonWKT(value)) {
      setWarning({ value: true, messssage: t("connectSettings.warningMessages.notValidPolygonWKT") })
    } else {
      setWarning({
        value: false,
        messssage: ""
      })
    }
  }

  return (
    <div>
      {warning.value && <Message message={warning.messssage} />}
      <div style={{ fontWeight: 600, marginBottom: "10px" }}>
        <label>
          {props.boundaryInput === BoundaryInputType.wkt
            ? t("connectSettings.inputForm.wktLabel")
            : props.active === CRSType.GeoCRS
              ? t("connectSettings.inputForm.geoLabel")
              : t("connectSettings.inputForm.projectedLabel")}
        </label>
      </div>
      <div style={{ width: "100%", minHeight: "240px", display: "flex" }}>
        {geoCoordinatesLoading || loading ? (
          <div className="w-100">
            <PendingSpinner />
          </div>
        ) : (
          <textarea
            placeholder={
              props.boundaryInput === BoundaryInputType.wkt
                ? t("connectSettings.inputForm.wktPlaceholder")
                : props.active === CRSType.GeoCRS
                  ? t("connectSettings.inputForm.geoPlaceholder")
                  : t("connectSettings.inputForm.projectedPlaceholder")
            }
            value={formData}
            onChange={props.boundaryInput === BoundaryInputType.wkt ? handleWKTChange : handleJSONChange}
            rows={5}
            cols={50}
          />
        )}
      </div>
      <br />
    </div>
  )
}

export default ProjectBoundaryForm

const Message = ({ message }: { message: string }) => {
  // Component to display warning message
  return (
    <div
      className="d-flex justify-content-between"
      style={{
        backgroundColor: "rgba(244, 209, 211, .5)",
        border: "1px solid #ccc",
        padding: "10px",
        borderRadius: "5px",
        fontSize: "16px",
        color: "#a51d25"
      }}
    >
      <p>{message}</p>
    </div>
  )
}
